<panel *ngIf="!loading || !partners.empty">
  <p header>{{"Danh sách đối tác" | lang}}</p>
  <div right class="flex column">
    <text-filter [target]="partners" [placeholder]="'Tìm khách'"></text-filter>
    <button class="bg-success text-white std-margin-left" (click)="edit(null)"><i class="fa fa-plus"></i></button>
    <button class="bg-primary text-white std-margin-left" (click)="synchronize()"><i class="fa fa-sync"></i></button>
  </div>
  <table responsive class="data hover">
    <tr>
      <th priority="9" class="text-right" style="width: 0px">STT</th>
      <th priority="8" class="text-center"><sortable [target]="partners" [extractor]="extractor('ID')">{{"Mã" | lang}}</sortable></th>
      <th priority="1" class="text-left nowrap"><sortable [target]="partners" [extractor]="extractor('Name')" [selected]="true">{{"Tên" | lang}}</sortable></th>
      <th priority="3" class="text-left"><sortable [target]="partners" [extractor]="extractor('Address')">{{"Địa chỉ" | lang}}</sortable></th>
      <th priority="4" class="text-center"><sortable [target]="partners" [extractor]="extractor('Phone')">{{"SĐT" | lang}}</sortable></th>
      <th priority="5" class="text-center"><sortable [target]="partners" [extractor]="extractor('Email')">{{"email" | lang}}</sortable></th>
      <th priority="2" class="text-center"><sortable [target]="partners" [extractor]="extractor('Dealer')">{{"Phụ trách" | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of partners.pageMatches; index as ix" class="pointer" (click)="edit(i)">
      <td><small>{{ix + 1 + partners.pageIndex * partners.pageSize}}</small></td>
      <td class="spacy text-primary">K{{i.ID}}</td>
      <td class="uppercase bold">{{i.Name}}</td>
      <td><els>{{i.Address}}</els></td>
      <td>{{i.Phone}}</td>
      <td>{{i.Email}}</td>
      <td [ngClass]="{'text-success': i.DealerID > 0}">{{i.DealerID > 0 ? dealer(i) : 'chưa có'}}</td>
    </tr>
    <tr class="footer">
      <td [colSpan]="7" class="text-center"><pagination [target]="partners"></pagination></td>
    </tr>
  </table>
</panel>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
